export interface OrderServiceAccessOption {
  key: string;
  label: string;
}

export const ORDER_SERVICE_ACCESS_OPTIONS: OrderServiceAccessOption[] = [
  { key: 'all', label: '所有订单' },
  { key: 'trademark', label: '商标服务' },
  { key: 'madrid', label: '马德里商标' },
  { key: 'patent', label: '专利服务' },
  { key: 'copyright', label: '版权服务' },
  { key: 'company', label: '工商服务' },
  { key: 'barcode', label: '条形码服务' },
  { key: 'other', label: '其他服务' },
];

export const ORDER_SERVICE_ACCESS_LABELS: Record<string, string> = ORDER_SERVICE_ACCESS_OPTIONS.reduce((labels, option) => {
  labels[option.key] = option.label;
  return labels;
}, {} as Record<string, string>);

export const ORDER_SERVICE_ACCESS_KEYS = ORDER_SERVICE_ACCESS_OPTIONS.map(option => option.key);

export const getOrderServiceAccessPermissionName = (serviceKey: string): string => (
  `page.order-management.service.${serviceKey}.view`
);
